import { render, staticRenderFns } from "./saleCategoriesTable.vue?vue&type=template&id=6d4ca7cc&"
import script from "./saleCategoriesTable.vue?vue&type=script&lang=js&"
export * from "./saleCategoriesTable.vue?vue&type=script&lang=js&"
import style0 from "./saleCategoriesTable.vue?vue&type=style&index=0&id=6d4ca7cc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports